'use client';
import Image from 'next/image';
import Link from 'next/link';
import {localeHref, useLocale} from '../../i18n';

interface BrandLogoProps {
  logoUrl: string;
  logoUrlByLocale?: Record<string, string>;
  alt: string;
  width: number;
  height: number;
  heightByLocale?: Record<string, number | 'auto'>;
  priority?: boolean;
  href?: string;
}

export function BrandLogo({logoUrl, logoUrlByLocale, alt, width, height, heightByLocale, priority = false, href}: BrandLogoProps) {
  const locale = useLocale();
  const src = logoUrlByLocale?.[locale] ?? logoUrl;
  const localeHeight = heightByLocale?.[locale];
  const localeStyle = localeHeight ? {width: localeHeight === 'auto' ? width : 'auto', height: localeHeight} : undefined;
  return (
    <Link href={href ?? localeHref(locale)}>
      <Image src={src} alt={alt} style={localeStyle} width={width} height={height} priority={priority} />
    </Link>
  );
}

BrandLogo.displayName = 'BrandLogo';
